import { functions } from './firebase';

export const deleteMember = async ({ userId }) => {
  
  if (!userId) { return; }

  try {
    await functions.httpsCallable('adminDeleteUser')({
      id: userId
    });
    return { success: true, message: "Konto raderat." };
  } catch (error) {
    return { success: false, message: "Kunde inte radera konto. " + error.message };
  }

};

